import styled from "styled-components";

export const Container = styled.div`
	@media print {
		 html, body {
			height: 100vh; /* Use 100% here to support printing more than a single page*/
			margin: 0 !important;
			padding: 0 !important;
			overflow: hidden;
		}

		@page {
			size: 95mm 180mm;
			// height: 1000vh;
		}
	}
`;